import Vue from 'vue'
import Vuex from 'vuex'
import context from './modules/context'
import depo from './modules/depo'
import chat from './modules/chat'
import favorite from './modules/favorite'
import client from './modules/client'
import clientRender from './modules/ClientRender'
import open from './modules/open'
import report from './modules/report'
import assist from './modules/assist'
import people from './modules/people'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  modules: {
    context,
    depo,
    chat,
    client,
    clientRender,
    open,
    favorite,
    people,
    report,
    assist
  },
  strict: debug
})



// WEBPACK FOOTER //
// ./src/store/index.js